const chartjs = require('../../../../../../components/chart/chartjs')
const { changeSVG } = require('../../../../../../js-handler/graphic')
let barSimpleChart = null;

export function createChart(parameter) {
	const canvas = document.getElementById('chartBarCustomerProfit');
	const datetimeSpan = document.getElementById('datetimeSpanCustomerProfit');
	const companyName = document.getElementById('companyNameCustomerProfit');

	companyName.textContent = parameter[0].company_name;
	datetimeSpan.textContent = parameter[0].current_dateTime;

	// Destruye el gráfico anterior si existe
	if (barSimpleChart) {
		barSimpleChart.destroy();
		barSimpleChart = null;
	}

	// Inicializar totales
	let last_24_h = 0;
	let last_7_d = 0;
	let last_15_d = 0;
	let last_30_d = 0;
	let last_90_d = 0;
	let over_90_d = 0;
	let total = 0;

	//Sumar todos los valores del parámetro
	parameter.forEach(element => {
		last_24_h += parseFloat((element.last_24_hours || '0').replace(/[^0-9.-]+/g, ""));
		last_7_d += parseFloat((element.last_7_days || '0').replace(/[^0-9.-]+/g, ""));
		last_15_d += parseFloat((element.last_15_days || '0').replace(/[^0-9.-]+/g, ""));
		last_30_d += parseFloat((element.last_30_days || '0').replace(/[^0-9.-]+/g, ""));
		last_90_d += parseFloat((element.last_90_days || '0').replace(/[^0-9.-]+/g, ""));
		over_90_d += parseFloat((element.over_90_days || '0').replace(/[^0-9.-]+/g, ""));
	});

	total = parseFloat(last_24_h + last_7_d + last_15_d + last_30_d + last_90_d + over_90_d)

	//Prepara los datos para el gráfico
	const chartData = {
		labels: ['Last 24 hours', 'Last 7 days', 'Last 15 days', 'Last 30 days', 'Last 90 days', 'Over 90 days', 'Total'],
		dataset: [
			{
				label: 'Customer Profit',
				backgroundColor: ['#36a2eb', '#4bc0c0', '#ffcd56', '#f86624', '#ff2857', '#f36cde', '#9661ff'],
				data: [last_24_h, last_7_d, last_15_d, last_30_d, last_90_d, over_90_d, total],
			}
		]
	};


	//Crear gráfico solo una vez con los totales
	barSimpleChart = chartjs.start({
		elem: 'bar',
		act: 'createMultipleLineWithLabels',
		targetChart: { html: canvas },
		data: chartData,
		options: {
			aspectRatio: 10 / 5,
			legend: false
		}
	});

	if (!canvas) {
		console.log('Canvas chartBarCustomerProfit no encontrado');
		return;
	}

}